import { render } from "./JoinUsInfo.vue?vue&type=template&id=3aae1a15&scoped=true"
import script from "./JoinUsInfo.vue?vue&type=script&lang=js"
export * from "./JoinUsInfo.vue?vue&type=script&lang=js"

import "./JoinUsInfo.vue?vue&type=style&index=0&id=3aae1a15&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aae1a15"]])

export default __exports__